import React from "react";
import { CtaButton } from "./CtaButton";
type TransformCtaProps = {
  label: string;
  tone?: "light" | "dark";
};
export function TransformCta({
  label,
  tone = "light"
}: TransformCtaProps) {
  return <div className="mt-12" data-id="element-334" data-mp="2pacghxu7t6aj">
      <CtaButton label={label} size="md" data-id="element-335" data-mp="2p915bcyfww9e" />
      <p className={`mt-4 text-center text-sm ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-336" data-mp="2tbxr1cja18hk">
        Instant access · One-time payment of <strong className={tone === "dark" ? "text-white" : "text-ink"} data-id="element-337" data-mp="2yahejhdiqsc1">$27 USD</strong> · 7-day guarantee
      </p>
    </div>;
}